import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";
import { DeliveryCompany } from "../../deliveryCompanies.types";
import { UpdateDeliveryCompanyRequestBody } from "./updateDeliveryCompany.types";

export const requestUpdateDeliveryCompany = async (
  body: UpdateDeliveryCompanyRequestBody
): Promise<DeliveryCompany> => {
  return await instance.put(ApiRoutesDeliveryCompanies.Companies, body);
};
